import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  TextField,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";
import HubbleRequests from "services/hubble";

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function AddJudgeAccess({
  open,
  handleClose,
}) {
  const [nationalCode, setNationalCode] = useState("");

  const classes = useStyles();
  const dispatch = useDispatch();

  const handleAddUserAccess = () => {
    dispatch(HubbleRequests.addJudge(nationalCode))
    handleClose();
    reset();
  };

  const reset = () => {
    setNationalCode("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-add-user-access"
      aria-describedby="alert-add-user-access"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-user-description">
          اضافه کردن داور
        </DialogContentText>
        <GridContainer className={classes.girdContainer}>
      <Grid item xs={12} md={12} className={classes.inputContainer}>
        <Typography>کد ملی</Typography>
        <TextField
          id="nationalCodeInput"
          label="کد ملی"
          variant="outlined"
          className={classes.customInput}
          value={nationalCode}
          onChange={(e) => setNationalCode(e.target.value)}
        />
      </Grid>
    </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddUserAccess} color="primary">
          اضافه کردن
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
